class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);

    this.debouncedOnSubmit = debounce((event) => {
      const target = event.target;
      const referenceName = target.getAttribute('data-reference');
      const reference = document.querySelector(`#${referenceName}`);
      if (reference !== null) {
        reference.value = target.checked ? target.value : '';
      }
      this.onSubmitHandler(event);
    }, 500);

    const facetForm = this.querySelector('form');
    facetForm.addEventListener('input', this.debouncedOnSubmit.bind(this));

    document
      .querySelector('#month_input')
      .addEventListener('input', this.debouncedOnSubmit.bind(this));
    document
      .querySelector('#year_input')
      .addEventListener('input', this.debouncedOnSubmit.bind(this));

    const facetWrapper = this.querySelector('#FacetsWrapperDesktop');
    if (facetWrapper) facetWrapper.addEventListener('keyup', onKeyUpEscape);
  }

  static setInputs() {
    for (let [key, value] of Object.entries(FacetFiltersForm.searchParams)) {
      const domEL = document.querySelector(`input[name="${key}"]`);
      if (domEL !== null) domEL.value = value;
    }
  }

  static setListeners() {
    const onHistoryChange = (event) => {
      const searchParams = event.state
        ? event.state.searchParams
        : FacetFiltersForm.searchParamsInitial;
      if (searchParams === FacetFiltersForm.searchParamsPrev) return;
      FacetFiltersForm.renderPage(searchParams, null, false);
    };
    window.addEventListener('popstate', onHistoryChange);
  }

  static dropdownListener() {
    const inputs = document.querySelectorAll('[data-popup-input]');
    inputs.forEach((input) => {
      input.addEventListener('onblur', (event) => {
        FacetFiltersForm.toggleDisplayDropDown(event.target, 'none');
      });
      input.addEventListener('click', (event) => {
        FacetFiltersForm.toggleDisplayDropDown(event.target);
      });
    });
  }

  static singleCheckboxListener() {
    const inputs = document.querySelectorAll(
      '.facets__display input[type="checkbox"]',
    );
    inputs.forEach((input) => {
      input.addEventListener('click', (event) => {
        FacetFiltersForm.unselectCheckBoxes(event.target);
      });
    });
  }

  static unselectCheckBoxes(target) {
    const inputsContainer = target.closest('.facets__list');
    const inputs = inputsContainer.querySelectorAll('input[type="checkbox"]');
    inputs.forEach((input) => {
      if (input !== target) input.checked = false;
    });
  }

  static toggleDisplayDropDown(target, status) {
    const popup = target.parentNode.nextElementSibling;
    if (status !== undefined) {
      popup.style.display = status;
      return;
    }
    popup.style.display = popup.style.display !== 'block' ? 'block' : 'none';
  }

  static toggleActiveFacets(disable = true) {
    document.querySelectorAll('.js-facet-remove').forEach((element) => {
      element.classList.toggle('disabled', disable);
    });
  }

  static renderPage(searchParams, event, updateURLHash = true) {
    if (FacetFiltersForm.searchParamsPrev !== searchParams) {
      FacetFiltersForm.searchParamsPrev = searchParams;
      FacetFiltersForm.searchParams = FacetFiltersForm.queryValidParam(
        FacetFiltersForm.searchParamsPrev,
      );
      const sections = FacetFiltersForm.getSections();

      const countContainer = document.getElementById('ProductCount');
      const countContainerDesktop = document.getElementById(
        'ProductCountDesktop',
      );
      document
        .getElementById('ProductGridContainer')
        .querySelector('.collection')
        .classList.add('loading');

      if (countContainer) {
        countContainer.classList.add('loading');
      }

      if (countContainerDesktop) {
        countContainerDesktop.classList.add('loading');
      }

      const filters = document.getElementById('product-filters').dataset.id;
      const filterUrl = `${window.location.pathname}?section_id=${filters}&${searchParams}`;
      FacetFiltersForm.renderSectionFiltersFetch(filterUrl, event);

      sections.forEach((section) => {
        const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
        FacetFiltersForm.renderSectionFromFetch(url, event);
      });
      if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);
    }
  }

  static renderSectionFiltersFetch(url, event) {
    fetch(url)
      .then((response) => response.text())
      .then((responseText) => {
        const html = responseText;
        FacetFiltersForm.renderFilters(html, event);
      });
  }

  static renderSectionFromFetch(url, event) {
    fetch(url)
      .then((response) => response.text())
      .then((responseText) => {
        const html = responseText;
        FacetFiltersForm.filterData = [
          ...FacetFiltersForm.filterData,
          { html, url },
        ];
        FacetFiltersForm.renderProductGridContainer(html);
        if (typeof initializeScrollAnimationTrigger === 'function')
          initializeScrollAnimationTrigger(html.innerHTML);
      });
  }

  static renderSectionFromCache(filterDataUrl, event) {
    const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
    FacetFiltersForm.renderProductGridContainer(html);
    if (typeof initializeScrollAnimationTrigger === 'function')
      initializeScrollAnimationTrigger(html.innerHTML);
  }

  static renderProductGridContainer(html) {
    document.getElementById('ProductGridContainer').innerHTML = new DOMParser()
      .parseFromString(html, 'text/html')
      .getElementById('ProductGridContainer').innerHTML;
  }

  static renderFilters(html, event) {
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');
    const facetDetailsElements = parsedHTML.querySelector('#product-filters');
    document.querySelector('#product-filters').innerHTML =
      facetDetailsElements.innerHTML;
    runFilters();
    FacetFiltersForm.setInputs();
    FacetFiltersForm.setListeners();
    FacetFiltersForm.dropdownListener();
    FacetFiltersForm.singleCheckboxListener();
  }

  static renderActiveFacets(html) {
    const activeFacetElementSelectors = [
      '.active-facets-mobile',
      '.active-facets-desktop',
    ];

    activeFacetElementSelectors.forEach((selector) => {
      const activeFacetsElement = html.querySelector(selector);
      if (!activeFacetsElement) return;
      document.querySelector(selector).innerHTML =
        activeFacetsElement.innerHTML;
    });

    FacetFiltersForm.toggleActiveFacets(false);
  }

  static renderAdditionalElements(html) {
    const mobileElementSelectors = [
      '.mobile-facets__open',
      '.mobile-facets__count',
      '.sorting',
    ];

    mobileElementSelectors.forEach((selector) => {
      if (!html.querySelector(selector)) return;
      document.querySelector(selector).innerHTML =
        html.querySelector(selector).innerHTML;
    });

    documentrenderAdditionalElements

      .getElementById('FacetFiltersFormMobile')
      .closest('menu-drawer')
      .bindEvents();
  }

  static renderCounts(source, target) {
    const targetElement = target.querySelector('.facets__selected');
    const sourceElement = source.querySelector('.facets__selected');

    const targetElementAccessibility = target.querySelector('.facets__summary');
    const sourceElementAccessibility = source.querySelector('.facets__summary');

    if (sourceElement && targetElement) {
      target.querySelector('.facets__selected').outerHTML =
        source.querySelector('.facets__selected').outerHTML;
    }

    if (targetElementAccessibility && sourceElementAccessibility) {
      target.querySelector('.facets__summary').outerHTML =
        source.querySelector('.facets__summary').outerHTML;
    }
  }

  static updateURLHash(searchParams) {
    history.pushState(
      { searchParams },
      '',
      `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`,
    );
  }

  static queryValidParam(string) {
    if (string == '') return {};
    const parts = string.split('&');
    const validValues = parts.filter((part) => {
      const elem = part.split('=');
      if (elem[1] !== undefined && elem[1] !== '') return true;
    });
    let uniqueSet = [...new Set(validValues)];
    const validString = uniqueSet.join('&');
    if (validString === '') return {};
    FacetFiltersForm.updateURLHash(validString);
    return JSON.parse(
      '{"' +
        decodeURI(validString)
          .replace(/"/g, '\\"')
          .replace(/&/g, '","')
          .replace(/=/g, '":"') +
        '"}',
    );
  }
  static getSections() {
    const list = document.getElementById('product-list');
    if (list === null) return null;
    return [
      {
        section: list.dataset.id,
      },
    ];
  }

  createSearchParams(form) {
    const formData = new FormData(form);
    return new URLSearchParams(formData).toString();
  }

  onSubmitForm(searchParams, event) {
    FacetFiltersForm.renderPage(searchParams, event, true);
  }

  onSubmitHandler(event) {
    if (event) {
      event.preventDefault();
    }
    const sortFilterForms = document.querySelectorAll(
      'facet-filters-form form',
    );
    const forms = [];

    sortFilterForms.forEach((form) => {
      if (form.id === 'FacetFiltersForm' || form.id === 'FacetSortDrawerForm') {
        const noJsElements = document.querySelectorAll('.no-js-list');
        noJsElements.forEach((el) => el.remove());
        forms.push(this.createSearchParams(form));
      }
    });
    const formsString = forms.join('&');
    const JSONFormat = FacetFiltersForm.queryValidParam(formsString);
    const result = [];
    for (let [key, value] of Object.entries(JSONFormat)) {
      result.push(`${key}=${value}`);
    }
    this.onSubmitForm(result.join('&'), event);
    const everntBanner = document.querySelector('.rhm-polygon-events');
    if (everntBanner !== null) everntBanner.classList.add('twcss-hidden');
  }

  onActiveFilterClick(event) {
    event.preventDefault();
    FacetFiltersForm.toggleActiveFacets();
    const url =
      event.currentTarget.href.indexOf('?') == -1
        ? ''
        : event.currentTarget.href.slice(
            event.currentTarget.href.indexOf('?') + 1,
          );
    FacetFiltersForm.renderPage(url);
  }
}

FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParams = FacetFiltersForm.queryValidParam(
  FacetFiltersForm.searchParamsInitial,
);
customElements.define('facet-filters-form', FacetFiltersForm);

FacetFiltersForm.setInputs();
FacetFiltersForm.setListeners();
FacetFiltersForm.dropdownListener();
FacetFiltersForm.singleCheckboxListener();

class FacetRemove extends HTMLElement {
  constructor() {
    super();
    const facetLink = this.querySelector('a');
    facetLink.setAttribute('role', 'button');
    facetLink.addEventListener('click', this.closeFilter.bind(this));
    facetLink.addEventListener('keyup', (event) => {
      event.preventDefault();
      if (event.code.toUpperCase() === 'SPACE') this.closeFilter(event);
    });
  }

  closeFilter(event) {
    event.preventDefault();
    const form =
      this.closest('facet-filters-form') ||
      document.querySelector('facet-filters-form');
    form.onActiveFilterClick(event);
  }
}

customElements.define('facet-remove', FacetRemove);
